import { createAPIService } from './api.service';

export const ORGANIZATIONS_ENDPOINT = '/synchub/api/v1/organization/hco';

export const service = createAPIService(ORGANIZATIONS_ENDPOINT);

service.searchHCO = async params =>
  (await service.get('/search', { params: params })).data;

export default service;
